import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import Button from '@material-ui/core/Button';
import '../styles/DashboardTableItem.css';
import bell from '../images/bell.gif';
import check from '../images/check.png';

class DashboardTableItem extends Component {
  constructor(props) {
    super(props);
 
}

  getColor = (alarmStatus, tag) => {
    if(!tag.includes("error")){
      if(alarmStatus === 0){
        return '#00a65a';
      }else if(alarmStatus === 1){
        return '#f39c12';
      }else{
        return '#dd4b39';
      }
    }else{
      if(alarmStatus === 0){
        return '#cccccc';
      }else{
        return '#444444';
      }
    }

  }

  displayAlert = (status, tag) => {
    if(status === 2 && !tag.includes("error") ){
      return 'block';
    }else{
      return 'none';
    }
  }

  displayCaption = (r) => {
    if(r.isAcknowledged === true){
      return r !== undefined && r.event !== null && r.event !== undefined ? r.event.summary : '';
    }else{
      return 'Click to acknowledge';
    }
  }

  
  displayImage = (status) => {
    if(status === true){
      return check;
    }else{
      return bell;
    }
    }

    getBorder = (tag, isExtended) => {
        if (isExtended && (tag.includes("wells-comms-failure") || tag.includes("wells-incomplete-tests"))) {
            return '9px double #404040';
        } else {
            return '';
        }
    }

  buttonAction = (tag, instanceId) => {
    if(instanceId != undefined){
      if(tag.includes("error")){
        this.props.history.push(`/Errors/${instanceId}`);
      }else if(!tag.includes("license")){
        this.props.history.push(`/History/${tag}/Instance/${instanceId}`);
      }
    }
    //Add more to add an action to the dashboard button regarding the tag
  }
  
  getValue = (value, tag) => {
    if(tag.includes("-date")){
      var options = { day:'2-digit', month: 'short', year:'2-digit', hour:  "2-digit",
      minute: "2-digit",
      second: "2-digit"};
      var options2 = { day:'2-digit', month: 'short', year:'2-digit'};
      const date =  new Date(value);
      const lastWord = tag.substr(tag.length-4);
      if(tag.includes("license")){
        var difference = Math.round((date.getTime() - new Date().getTime() )/(1000*60*60*24)); 
        return `${difference} Days Left - `+date.toLocaleDateString('en-GB', options2);
      }
      return ( lastWord !== 'date') ? date.toLocaleString('en-GB', options) : date.toLocaleDateString('en-GB', options2);
    }else{
      return value;
    }
  }

  render() {
      
      //const jsx = this.props.instance.registers.map( (register) => {
        let register= undefined;
        if(this.props.instance.registers !== undefined && this.props.instance.registers !== null && this.props.instance.registers !== []){
        register = this.props.instance.registers.find(
                      register => {
                        if(register[this.props.registerTag] !== undefined)
                         return register[this.props.registerTag].tag === this.props.registerTag;
                        else
                         return false; 
                      }
                  );
          }
            if(register !== undefined){
                return (<TableCell className="cell" style={
                    { borderRight: this.getBorder(register[this.props.registerTag].tag, this.props.isExtended) }}>
                  <div style= {
                        {display: 'inline-flex'}}>
                    <Button
                      style= {
                        {
                          color:'white',
                          backgroundColor: this.getColor(register[this.props.registerTag].alarmStatus,  register[this.props.registerTag].tag),
                          float: 'left',
                          fontSize: '1rem',
                          fontFamily: 'Open Sans',
                          textTransform: 'none'
                        }}
                        onClick={this.buttonAction.bind(this, register[this.props.registerTag].tag,this.props.instance.id)}
                    >
                      {
                        this.getValue(register[this.props.registerTag].value, register[this.props.registerTag].tag)
                      }
                    </Button>
                    <img src={this.displayImage(register[this.props.registerTag].isAcknowledged)} 
                    title={this.displayCaption(register[this.props.registerTag])} 
                    onClick={this.props.openDialog.bind(this, register[this.props.registerTag])}
                    style={{width:'30px',
                                                          height:'30px',
                                                          float: 'left',
                                                          cursor: 'pointer',
                                                          display: this.displayAlert(register[this.props.registerTag].alarmStatus, register[this.props.registerTag].tag)}}></img>
                                                          </div>
                  </TableCell>)
                }else{
                  return (<TableCell className="cell">
                    <Button
                      disabled
                      style= {
                        {
                          color:'white',
                          backgroundColor: '#CCCCCC',
                          fontSize: '1rem',
                          fontFamily: 'Open Sans'
                        }}
                        
                    >
                      {
                        "No data"
                      }
                    </Button>
                  </TableCell>)
                }
             // });   
  }
}

export default DashboardTableItem;


// WEBPACK FOOTER //
// ./src/components/DashboardTableItem.js